import { FileTypes } from "@/models/FileTypes"
import { createAsyncAction } from "typesafe-actions";

export type FileTypeSuccessPayload = {
    data: FileTypes[]
}

export const getFileTypes = createAsyncAction(
    'fileManagement/getFileTypes/request',
    'fileManagement/getFileTypes/success',
    'fileManagement/getFileTypes/failure',
)<undefined, FileTypeSuccessPayload, undefined>();